import React from 'react';
import '../../../../../assets/css/Modal.css'
import {
    Modal,
} from 'react-bootstrap';
import {toast, ToastContainer} from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import moment from "moment/moment";
import DatePicker, {registerLocale} from "react-datepicker";
import vi from "date-fns/locale/vi";
import YearController from "../../../../../services/data-declaration/year-controller";
import AutoSearchPeople from "../../../../../components/auto-search-people";
registerLocale("vi", vi);
class modalCreateSchoolYear extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            principalId: "",
            monthInSemester1: 4,
            monthInSemester2: 4,
            principalName: "",
            principalUsername: "",

            year: '',
            startYear: '',
            endYear: '',
            endSemesterOne: new Date(),
            endSemesterTwo: new Date(),
            startSemesterOne: new Date(),
            startSemesterTwo: new Date(),
            signupInfo: null
        };
    }
    createYear = () => {
        let payload = {
            kethua: this.state.remember,
            monthInSemester1: parseInt(this.state.monthInSemester1),
            monthInSemester2: parseInt(this.state.monthInSemester1),
            year: this.state.startYear.toString(),
            endSemesterOne: this.state.endSemesterOne,
            endSemesterTwo: this.state.endSemesterTwo,
            startSemesterOne: this.state.startSemesterOne,
            startSemesterTwo: this.state.startSemesterTwo,
            principalUsername: this.state.principalUsername
        }
        YearController.create(payload, res => {
            if (res.success) {
                toast.success("Thêm năm học thành công!", {
                    position: toast.POSITION.TOP_RIGHT,
                    autoClose: 3000
                });
                this.props.onHide();
                this.props.onRefresh()
            } else {
                toast.warning(res.message[0], {
                    position: toast.POSITION.TOP_RIGHT,
                    autoClose: 3000
                });
            }
        })
    }
    render() {
        const modalProp = {
            show: this.props.show,
            onHideModal: this.props.onHide,
            keyboard: false,
            backdrop: 'static',
        };
        return (
            <div>
                <Modal {...modalProp} dialogClassName="modal-dialog-centered full-width-dialog">
                    <div className="modal-container">
                        <div className="btn-close">
                            <button type="button" className="close" onClick={this.props.onHide}>
                                <span aria-hidden="true">&times;</span>
                            </button>
                        </div>
                    </div>
                    <Modal.Body>
                        <div>
                            <h1 className="text-center" style={{fontSize: 20,}}><b>Thêm thời gian năm học</b></h1>
                        </div>
                        <div className='d-flex justify-content-center mt-12 mb-12'>
                            <div className="row">
                                <div className="col-12 d-flex mb-4 row">
                                    <label className="col-12 label-item pl-0"><b>Dữ liệu sẽ được kế thừa từ năm học cũ nếu chọn "Kế thừa"</b></label>
                                    <label className="col-12 label-item pl-0">- Danh sách lớp học</label>
                                    <label className="col-12 label-item pl-0">- Danh sách môn học cho trường</label>
                                    <label className="col-12 label-item pl-0">- Danh sách môn học cho lớp</label>
                                </div>

                                <div className="col-md-5 col-xs-12 d-flex mb-2">
                                    <label className="col-5 label-item pl-0">Năm học(<span  style={{color: "red",}}>*</span>)</label>
                                    <input
                                        maxLength={4}
                                        type="number"
                                        className="form-control shadow-none"
                                        value={this.state.startYear}
                                        onChange={(event) => {
                                            this.setState({
                                                startYear: event.target.value
                                            })
                                        }}
                                    />
                                </div>
                                {/*<div className="col-md-5 col-xs-12 d-flex mb-2">*/}
                                {/*    <label className="col-5 label-item pl-0">Hiệu trường</label>*/}
                                {/*    <AutoSearchPeople*/}
                                {/*        principalId={this.state.principalId}*/}
                                {/*        principalName={this.state.principalName}*/}
                                {/*        principalUsername={this.state.principalUsername}*/}
                                {/*        onUpdateData={(principalId, principalUsername, principalName) => this.setState({principalId: principalId, principalName: principalName, principalUsername: principalUsername})}*/}
                                {/*    />*/}
                                {/*</div>*/}
                                <div className="col-md-2 col-xs-12 d-flex mb-2">
                                    <label>
                                        <input
                                            type="checkbox"
                                            onChange={(e) => {
                                                const value = this.state.remember;
                                                this.setState({remember: !value});
                                            }}
                                            checked={this.state.remember}
                                        />
                                        {' '}
                                        Kế thừa
                                    </label>
                                </div>
                                <div className="col-12 d-flex mb-4">
                                    <label className="col-12 label-item pl-0"><b>Thông tin chi tiết</b></label>
                                </div>
                                <div className="col-md-6 col-xs-12 d-flex mb-2">
                                    <label className="col-md-6 col-5 label-item pl-0">Số tháng / 1 học kỳ(<span  style={{color: "red",}}>*</span>)</label>
                                    <input
                                        maxLength={12}
                                        type="number"
                                        className="form-control shadow-none"
                                        value={this.state.monthInSemester1}
                                        onChange={(event) => {
                                            this.setState({
                                                monthInSemester1: event.target.value
                                            })
                                        }}
                                    />
                                </div>
                                {/*<div className="col-md-6 col-xs-12 d-flex mb-2">*/}
                                {/*    <label className="col-5 label-item pl-0">Số tháng học kỳ 2(<span  style={{color: "red",}}>*</span>)</label>*/}
                                {/*    <input*/}
                                {/*        maxLength={12}*/}
                                {/*        type="number"*/}
                                {/*        className="form-control shadow-none"*/}
                                {/*        value={this.state.monthInSemester2}*/}
                                {/*        onChange={(event) => {*/}
                                {/*            this.setState({*/}
                                {/*                monthInSemester2: event.target.value*/}
                                {/*            })*/}
                                {/*        }}*/}
                                {/*    />*/}
                                {/*</div>*/}
                                <div className="col-md-6 col-xs-12 d-flex mb-2"></div>
                                <div className="col-md-6 col-xs-12 d-flex mb-2">
                                    <label className="col-md-6 col-5 label-item pl-0">Ngày bắt đầu học kỳ I<span  style={{color: "red",}}>*</span></label>
                                    <DatePicker
                                        locale="vi"
                                        className="w-auto form-control kt-input pd-4-input hei-input"
                                        selected={this.state.startSemesterOne === '' ? null : new Date(this.state.startSemesterOne)}
                                        minDate={new Date()}
                                        placeholderText="Ngày-Tháng-Năm"
                                        dateFormat="dd-MM-yyyy"
                                        showMonthDropdown
                                        showYearDropdown
                                        onChange={
                                            (date) => {
                                                let value = moment(date).format("YYYY-MM-DD").toString();
                                                try {
                                                    this.setState({
                                                        startSemesterOne: value == "Invalid date" ? null : moment(value).format("YYYY-MM-DD"),
                                                        inEditing: true
                                                    })
                                                }catch (e) {

                                                }
                                            }
                                        }
                                    />
                                </div>

                                <div className="col-md-6 col-xs-12 d-flex mb-2">
                                    <label className="col-md-6 col-5 label-item pl-0">Ngày kết thúc học kỳ I<span  style={{color: "red",}}>*</span></label>
                                    <DatePicker
                                        locale="vi"
                                        className="w-auto  form-control kt-input pd-4-input hei-input"
                                        selected={this.state.endSemesterOne === '' ? null : new Date(this.state.endSemesterOne)}
                                        minDate={new Date()}
                                        placeholderText="Ngày-Tháng-Năm"
                                        dateFormat="dd-MM-yyyy"
                                        showMonthDropdown
                                        showYearDropdown
                                        onChange={
                                            (date) => {
                                                let value = moment(date).format("YYYY-MM-DD").toString();
                                                try {
                                                    this.setState({
                                                        endSemesterOne: value == "Invalid date" ? null : moment(value).format("YYYY-MM-DD"),
                                                        inEditing: true
                                                    })
                                                }catch (e) {

                                                }
                                            }
                                        }
                                    />
                                </div>
                                <div className="col-md-6 col-xs-12 d-flex mb-2">
                                    <label className="col-md-6 col-5 label-item pl-0">Ngày bắt đầu học kỳ II<span  style={{color: "red",}}>*</span></label>
                                    <DatePicker
                                        locale="vi"
                                        className="w-auto  form-control kt-input pd-4-input hei-input"
                                        selected={this.state.endSemesterTwo === '' ? null : new Date(this.state.endSemesterTwo)}
                                        minDate={new Date()}
                                        placeholderText="Ngày-Tháng-Năm"
                                        dateFormat="dd-MM-yyyy"
                                        showMonthDropdown
                                        showYearDropdown
                                        onChange={
                                            (date) => {
                                                let value = moment(date).format("YYYY-MM-DD").toString();
                                                try {
                                                    this.setState({
                                                        endSemesterTwo: value == "Invalid date" ? null : moment(value).format("YYYY-MM-DD"),
                                                        inEditing: true
                                                    })
                                                }catch (e) {

                                                }
                                            }
                                        }
                                    />
                                </div>

                                <div className="col-md-6 col-xs-12 d-flex mb-2">
                                    <label className="col-md-6 col-5 label-item pl-0">Ngày kết thúc học kỳ II<span  style={{color: "red",}}>*</span></label>
                                    <DatePicker
                                        locale="vi"
                                        className="w-auto  form-control kt-input pd-4-input hei-input"
                                        selected={this.state.startSemesterTwo === '' ? null : new Date(this.state.startSemesterTwo)}
                                        minDate={new Date()}
                                        placeholderText="Ngày-Tháng-Năm"
                                        dateFormat="dd-MM-yyyy"
                                        showMonthDropdown
                                        showYearDropdown
                                        onChange={
                                            (date) => {
                                                let value = moment(date).format("YYYY-MM-DD").toString();
                                                try {
                                                    this.setState({
                                                        startSemesterTwo: value == "Invalid date" ? null : moment(value).format("YYYY-MM-DD"),
                                                        inEditing: true
                                                    })
                                                }catch (e) {

                                                }
                                            }
                                        }
                                    />
                                </div>
                            </div>
                        </div>


                        <div className="d-flex align-right col-md-12 col-xs-12 row">
                            <div className="d-flex justify-content-center align-center mt-3 mb-2 col-md-12 col-xs-12">
                                <button
                                    style={{minWidth: "fit-content", marginRight: "10px"}}
                                    type="button"
                                    className="col-md-2 col-xs-2 border-1-s background-btn w-50 type-button-fix btn btn-primary"
                                    onClick={() => this.createYear()}
                                >
                                        <span className='justify-content-center'>
                                            Đồng ý
                                        </span>
                                </button>
                                <button
                                    style={{minWidth: "fit-content"}}
                                    type="button"
                                    className="col-md-2 col-xs-2 border-1-s w-50 type-button-fix btn btn-secondary"
                                    onClick={this.props.onHide}
                                >
                                        <span className=''>
                                            Hủy
                                        </span>
                                </button>
                            </div>
                        </div>

                    </Modal.Body>
                </Modal>
            </div>
        );
    }
}
export  default  modalCreateSchoolYear
